import React from 'react'
import { Eye, Users, CalendarDays } from 'lucide-react'
import { formatNumber } from '../utils/format'

export default function VisitorStats({ visits }) {
  if (!visits) return null

  const items = [
    { label: 'Today', value: visits.daily, icon: Eye },
    { label: 'This month', value: visits.monthly, icon: CalendarDays },
    { label: 'All time', value: visits.total, icon: Users },
  ]

  return (
    <div className="onds-card p-3 md:p-4 flex flex-wrap items-center gap-x-6 gap-y-2">
      <span className="text-xs uppercase tracking-wider text-[var(--onds-text-dim)]">Visitors</span>
      {items.map(({ label, value, icon: Icon }) => (
        <div key={label} className="flex items-center gap-2">
          <Icon className="h-4 w-4" style={{ color: 'var(--onds-accent)' }} />
          <span className="text-lg font-bold tabular-nums">{formatNumber(value)}</span>
          <span className="text-xs text-[var(--onds-text-dim)]">{label}</span>
        </div>
      ))}
    </div>
  )
}
